import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills, technicalSkills } from "../data";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { makeStyles } from "@material-ui/styles";
import { generalFormStyles } from './StyleObjects/generalStyles';


const useFormStyles = makeStyles(generalFormStyles);

export function SkillCard({ technicalSkills }) {
    const classes = useFormStyles();
    return (
        <Grid className={classes.skills}>
            <span>
                {technicalSkills.title}
            </span>
        </Grid>
    );
}